{
    "Profile_CommonComponents_Message.needHelp": "FR: Need help with your quote?",
    "Profile_CommonComponents_Message.directMessage": "FR: Send me a direct message from ",
    "Profile_CommonComponents_Message.messagesPage": "FR: your messages page",
    "Profile_CommonComponents_Message.orCall": "FR: or call ",
    "Profile_CommonComponents_Message.phoneNumber": "1-888-6-COVERA",
    "Profile_CommonComponents_Message.title": "FR: I have prepared this quote for you.",
    "Profile_CommonComponents_Message.signature": "FR: Talk to you soon,",
    "Profile_CommonComponents_Message.save": "FR: Save",
    "Profile_CommonComponents_Message.reply": "FR: Reply"
}
